import React, { useState, useEffect } from 'react';
import './BatchFilterToggle.css';

const BatchFilterToggle = ({ 
  currentFilter, 
  onFilterChange, 
  loading = false,
  counts = { assigned: 0, unassigned: 0 }
}) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
    const timer = setTimeout(() => setAnimate(false), 300);
    return () => clearTimeout(timer);
  }, [currentFilter]);

  return (
    <div className="batch-filter-toggle">
      <div className="filter-header">
        <h3>Filter Cases by Assignment Status</h3>
      </div>
      
      <div className="filter-buttons-container">
        <button
          className={`filter-button filter-button--assigned ${
            currentFilter === 'assigned' ? 'active' : ''
          } ${animate && currentFilter === 'assigned' ? 'pulse' : ''}`}
          onClick={() => onFilterChange('assigned')}
          disabled={loading}
          title="View all cases currently assigned to batches"
        >
          <span className="filter-button-icon">📋</span>
          <span className="filter-button-label">
            Assigned Cases
          </span>
          {counts.assigned > 0 && (
            <span className="filter-button-count">{counts.assigned}</span>
          )}
        </button>

        <div className="filter-divider"></div>

        <button
          className={`filter-button filter-button--unassigned ${
            currentFilter === 'unassigned' ? 'active' : ''
          } ${animate && currentFilter === 'unassigned' ? 'pulse' : ''}`}
          onClick={() => onFilterChange('unassigned')}
          disabled={loading}
          title="View all cases that have never been assigned to any batch"
        >
          <span className="filter-button-icon">✨</span>
          <span className="filter-button-label">
            Unassigned Cases
          </span>
          {counts.unassigned > 0 && (
            <span className="filter-button-count">{counts.unassigned}</span>
          )}
        </button>
      </div>

      <div className="filter-info">
        <p className="info-text">
          {currentFilter === 'assigned' ? (
            <>
              <strong>Assigned Cases</strong> - Cases currently assigned to one or more batches.
              These cases cannot be reassigned to prevent data contamination.
            </>
          ) : (
            <>
              <strong>Unassigned Cases</strong> - Cases that have never been assigned to any batch.
              These are available for assignment to new batches.
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default BatchFilterToggle;
